export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14023.770f376c.jpg";